import { searchParamsToString, } from '@moderepo/mode-data-state-base';
import createCachedSelector from 're-reselect';
/**
 * This is the actual function that will get the data from the state and return the data requested. However, this function returns a new
 * object every time which can cause an infinite loop in re-rendering if used in React component. Therefore this function is not EXPORTED
 * and we will create another function below which use memoize to cache the result.
 */
const selectSubscriptionsFunc = (subscriptionsById, subscriptionIds, searchParams) => {
    const dataSet = subscriptionIds[searchParams];
    if (dataSet) {
        // This will return a new PaginationDataSet of MetricsReportSubscription which can cause infinite loop if we don't use memoize
        return {
            range: dataSet.range,
            items: dataSet.items.reduce((result, subscriptionId) => {
                const subscription = subscriptionsById[subscriptionId];
                if (subscription) {
                    return [
                        ...result,
                        subscription,
                    ];
                }
                return result;
            }, []),
        };
    }
    return undefined;
};
export const selectMetricsReportSubscriptions = createCachedSelector((state) => { return state.metricsReportSubscriptions.subscriptionsById; }, (state) => { return state.metricsReportSubscriptions.subscriptionIds; }, (state, searchParams) => { return searchParamsToString(searchParams); }, selectSubscriptionsFunc)((state, searchParams) => {
    return searchParamsToString(searchParams);
});
/**
 * Return a metrics report subscription by subscription id
 * @param state
 * @param subscriptionId
 */
export const selectMetricsReportSubscriptionById = (state, subscriptionId) => {
    return state.metricsReportSubscriptions.subscriptionsById[subscriptionId];
};
